const INTEGER_TOLERANCE = 1e-9;

/**
 * Planner quantities may be fractional when **`sku_divisors`** applies to serialized rows
 * (for example one **3PH** serial counts as **⅓** shipment qty). Whole numbers render without decimals.
 */
export function formatPackQty(value: number): string {
  const nearestInt = Math.round(value);
  if (Math.abs(value - nearestInt) < INTEGER_TOLERANCE) {
    return String(nearestInt);
  }
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
}
